import styled from 'styled-components';

export const OcrResultEditorWrapper = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh;
    width: 100%;
    background: #FFFFFF;
`;

export const StyledTextarea = styled.textarea<{ $isDirty?: boolean }>`
    width: 100%;
    height: 100%;
    resize: none;
    border: 1px solid #FAFAFA;
    padding: 16px;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.8;
    white-space: pre-wrap;
    overflow-wrap: normal;
    overflow: auto;
    box-sizing: border-box;
    color: #262626;
    background: ${({ $isDirty }) => $isDirty ? '#F5F5F5' : '#FFFFFF'};
    border-top: ${({ $isDirty }) => $isDirty ? '1px solid #F5F5F5' : 'none'}; // #E2E8F0
    transition: box-shadow 0.2s;

    &:focus {
        background: #FAFAFA;
        transition: background 0.4s;
        outline: none;
    }
`;